// src/pages/Events/EventRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedPeopleFromInteraction } from "api/Interactions/InteractionAPI";


interface EventRightDrawerProps {
  eventId: number;
}

const EventRightDrawer: React.FC<EventRightDrawerProps> = ({
  eventId,
}) => {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch people attached to the TextMessage interaction
  // --------------------------------------------------
  const fetchPeople = async () => {
    const people = await getLinkedPeopleFromInteraction("event", eventId);
    
    return people.map((p: any) => ({
      id: p.id,
      primary: `${p.first_name} ${p.last_name}`,
      secondary: p.phone_number,
    }));
  };

  // --------------------------------------------------
  // Send texts = move people forward through pathway
  // --------------------------------------------------
  const handleSendEvents = async (selected: any[]) => {
    if (!selected.length) return;

    await moveItemsBetweenNodes({
      item_field_name: "people",
      selected_items: selected.map(p => p.id),
      handle_name: "output-7",
      direction: "forward",
      interaction_id: eventId,
      interaction_type: "event",
    });
  };

  return (
    <ActionOnRecord
      fetchData={fetchPeople}
      onAction={handleSendEvents}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Attendance of Event"
    />
  );
};

export default EventRightDrawer;
